module.exports = __webpack_public_path__ + "static/media/left-quote.90937447.svg";